import { MantineThemeOverride } from '@mantine/core';

export type RatingTheme = NonNullable<MantineThemeOverride['components']>['Rating'];

export const Rating: RatingTheme = {
  // todo: define
};
